import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldsGridComponent } from './fields-grid.component';
import {TabModule} from '../tab/tab.module';
import {
    DxButtonModule,
    DxColorBoxModule,
    DxDataGridModule,
    DxLoadPanelModule, DxPopoverModule,
    DxPopupModule,
    DxSelectBoxModule,
    DxSwitchModule
} from 'devextreme-angular';
import {FieldDrawModule, FieldSvgModule, GridDefaultModule, GridTitleModule} from 'shared';
import {UserDomainsChooserModule} from '../user-domains/user-domains-chooser/user-domains-chooser.module';
import {IconModule} from '@visurel/iconify-angular';
import {FieldCropsPopupModule} from '../field-crops/field-crops-popup/field-crops-popup.module';



@NgModule({
  declarations: [FieldsGridComponent],
    imports: [
        CommonModule,
        TabModule,
        DxDataGridModule,
        FieldSvgModule,
        FieldDrawModule,
        DxSelectBoxModule,
        DxLoadPanelModule,
        DxPopupModule,
        DxColorBoxModule,
        DxButtonModule,
        UserDomainsChooserModule,
        DxSwitchModule,
        IconModule,
        GridTitleModule,
        GridDefaultModule,
        FieldCropsPopupModule,
        DxPopoverModule
    ],
  exports: [FieldsGridComponent]
})
export class FieldsGridModule { }
